import Vue from 'vue'
import Vuex from 'vuex'

import app from './modules/app'
import user from './modules/user'
import permission from './modules/permission'
import getters from './getters'
import exportConfig from './modules/exportConfig'
import file from './modules/file'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    app,
    user,
    permission,
    exportConfig,
    file
  },
  state: {},
  getters,
  mutations: {},
  actions: {},
})
